import React, { useEffect, useState } from "react";
// Loader component
const Loader = ({ delay }) => {
    const [showLoader, setShowLoader] = useState(true);
  
    useEffect(() => {
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, delay);
  
      return () => clearTimeout(timeout);
    }, [delay]);


  
  return showLoader ? (
    <div className="flex justify-center items-center h-full">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
    </div>
  ) : null;
};
export default Loader;